import styles from "./Result.module.css";
import DateBar from "../../components/DateBar/DateBar";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

function Result() {
	const { t } = useTranslation(["result"]);
	const location = useLocation();
	const { caseData } = location.state;

	return (
		<div>
			<DateBar />
			<Header />

			<div className={styles.result_container}>
				<div className={styles.item_title}>
					<h1>{t("result_title")}</h1>
					<hr />
				</div>

				<div className={styles.result_case_content}>
					<div className={styles.result_case_content_item}>
						<h1>{t("result_case_number")}</h1>
						<p id="case_number">{caseData.caseNumber}</p>
					</div>
					<div className={styles.result_case_content_item}>
						<h1>{t("result_case_status")}</h1>
						<p id="case_result">{caseData.caseStatus}</p>
					</div>
					<div className={styles.result_case_content_item}>
						<h1>{t("result_case_date")}</h1>
						<p id="case_date">{caseData.registrationDate}</p>
					</div>
				</div>

				<div className={styles.item_title}>
					<h1>{t("result_appo_date_title")}</h1>
					<hr />
				</div>

				<div className={styles.result_appo_content}>
					<div className={styles.result_appo_date_cntr}>
						<h1>{t("result_appo_date")}</h1>
						<p id="case_appo_date">{caseData.appoDate}</p>
					</div>

					<p
						style={{
							fontSize: "0.8rem",
						}}>
						{t("result_appo_desc", { date: caseData.appoDate })}
					</p>
				</div>
			</div>
			<Footer />
		</div>
	);
}

export default Result;
